import React, { useState, useEffect, useRef } from "react";
import "./styles/styles.css";
import "../../styles/global.css";
import TableRow from "./components/TableRow";
import TableHeader from "../TableHeader/TableHeader";

const TableThird = ({
  options,
  data,
  onClick,
  onDownloadClick,
  onCheckboxClick,
  forUsers,
  isLoadingData,
  onActionClick,
  scrollPosition = 0,
  query,
  onDeleteClick,
  showSaveButton,
  verifiers,
  onStatusClick,
  onSortChange,
  className,
  sortField,
  sortDirection,
  setSelectedStatusOptions,
  selectedStatusOptions,
  classNameContent = "",
  onNameClick,
  selectedSuggestionsOptions,
  setSelectedSuggestionsOptions,
  onAddSubgroupClick,
  eventGroups,
  onSendMail,
  onGenerateAccr,
  onSendInvite,
}) => {
  const [seeAllColumns, setSeeAllColumns] = useState(false);
  const scrollRef = useRef(null);

  const ITEM_HEIGHT = 50;
  const BUFFER = 10;
  const [visibleStartIndex, setVisibleStartIndex] = useState(0);
  const [visibleEndIndex, setVisibleEndIndex] = useState(100);

  const handleScroll = () => {
    if (!scrollRef.current) return;

    const scrollTop = scrollRef.current.scrollTop;
    const clientHeight = scrollRef.current.clientHeight;

    const startIndex = Math.floor(scrollTop / ITEM_HEIGHT) - BUFFER;
    const endIndex =
      Math.ceil((scrollTop + clientHeight) / ITEM_HEIGHT) + BUFFER;

    setVisibleStartIndex(Math.max(0, startIndex));
    setVisibleEndIndex(Math.min(updatedData.length, endIndex));
  };

  const updatedData = data?.map((item) => {
    const widthValues = {};

    options.forEach((option) => {
      widthValues[option.name.toLowerCase()] = option.width;
    });

    return { ...item, width: widthValues };
  });
  const totalWidth = options.reduce((sum, opt) => sum + opt.width, 0);

  const placeholderRows = Array.from({ length: 6 }, (_, index) => ({
    id: `placeholder-${index}`,
    className: "animated-bg-text animated-bg",
    rowData: Array.from({ length: options.length }, (_, i) => ({
      key: String(i),
      width: options[i].width,
      className: `${options[i].name} ${options[i].class}`,
    })),
  }));

  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = scrollPosition;
    }
  }, [scrollPosition]);

  return (
    <div
      className={`flex-direction-column gap-12 items-end table-third-wrapper relative ${
        seeAllColumns ? "show" : ""
      } ${className ? className : ""}`}
    >
      <div
        className={`flex-direction-column width-100 table-third relative ${
          seeAllColumns ? "show" : ""
        } ${forUsers ? "for-users" : ""}`}
      >
        {
          <TableHeader
            options={options}
            totalWidth={totalWidth}
            seeAllColumns={seeAllColumns}
            setSeeAllColumns={(value) => setSeeAllColumns(value)}
            hasMany={updatedData.length > 9}
            sortField={sortField}
            sortDirection={sortDirection}
            onSortChange={onSortChange}
            selectedStatusOptions={selectedStatusOptions}
            setSelectedStatusOptions={setSelectedStatusOptions}
            selectedSuggestionsOptions={selectedSuggestionsOptions}
            setSelectedSuggestionsOptions={setSelectedSuggestionsOptions}
            className={forUsers ? "for-users" : ""}
          />
        }
        <div
          className={`flex-directions-column table-third-content ${classNameContent} relative
            ${forUsers ? "for-users" : ""} ${seeAllColumns ? "show" : ""}`}
          ref={scrollRef}
          onScroll={handleScroll}
        >
          {!isLoadingData ? (
            <>
              <div style={{ height: visibleStartIndex * ITEM_HEIGHT }} />
              {updatedData
                .slice(visibleStartIndex, visibleEndIndex)
                .map((rowData, index, arr) => (
                  <TableRow
                    key={rowData.id || index}
                    rowData={rowData}
                    totalWidth={totalWidth}
                    onClick={(key) => onClick(key)}
                    onDownloadClick={(key) => onDownloadClick(key)}
                    onCheckboxClick={(value) =>
                      onCheckboxClick(value, rowData.id)
                    }
                    seeAllColumns={seeAllColumns}
                    forUsers={forUsers}
                    isLoadingData={isLoadingData}
                    onActionClick={onActionClick}
                    isLast={index === arr.length - 1}
                    query={query}
                    onDeleteClick={onDeleteClick}
                    showSaveButton={showSaveButton}
                    verifiers={verifiers}
                    onStatusClick={onStatusClick}
                    onNameClick={onNameClick}
                    onAddSubgroupClick={onAddSubgroupClick}
                    eventGroups={eventGroups}
                    onSendMail={onSendMail}
                    onGenerateAccr={onGenerateAccr}
                    onSendInvite={onSendInvite}
                  />
                ))}
              <div
                style={{
                  height: (updatedData.length - visibleEndIndex) * ITEM_HEIGHT,
                }}
              />
            </>
          ) : (
            <React.Fragment>
              {placeholderRows?.map((rowData, index) => (
                <TableRow
                  key={`placeholder-${index}`}
                  rowData={rowData.rowData}
                  totalWidth={totalWidth}
                  isPlaceholder={true}
                  seeAllColumns={seeAllColumns}
                  forUsers={forUsers}
                  isLoadingData={isLoadingData}
                  query={query}
                />
              ))}
            </React.Fragment>
          )}
        </div>
      </div>
    </div>
  );
};

export default TableThird;
